module.exports = __webpack_public_path__ + "static/media/icon-apple.0f0a0ada.svg";